import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CodeDesignation } from '../models/codeDesignation.model';
import {AuthCoreService} from './auth-core.service';

@Injectable({
	providedIn: 'root'
})
export class LanguesService {
	private url = '/ws/langue';

	constructor(private http: HttpClient, private authService: AuthCoreService) {
	}

	/**
	 * Récupère les langues actives.
	 */
	actives(): Observable<CodeDesignation[]> {
		return this.http.get<CodeDesignation[]>(`${this.url}/actives`);
	}

	/**
	 * Mémorise la langue sélectionnée par l'utilisateur et modifie la langue dans la session côté serveur.
	 * @param {string} codeLangue le code langue.
	 */
	memoriserLangue(codeLangue: string) {
		this.http.post(this.url + '/' + codeLangue, null, {observe: 'response', responseType: 'text'})
					.toPromise()
					.then(response => {
						if (localStorage.getItem('access_token')) {
							this.authService.saveToken(response.headers);
						}
					});
	}
}
